import React from "react";
import ReactDOM from "react-dom/client";
import "./Style/App.scss";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home, Navigation } from "./Components";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Navigation />
    <Routes>
      <Route path="/" element={<Home />} />
    </Routes>
  </BrowserRouter>
);
